<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else id='deployments' class="box">
    <div class="col-6">
      <MetricGraph :metrics='metrics' :graphProperties='graphProperties' v-on:updateMetric='updateMetric' />
    </div>
    <div class="col-6">
      <MetricData :graphProperties='graphProperties' :metric='metric' />
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import MetricGraph from '@/components/MetricGraph'
import MetricData from '@/components/Deployment/MetricData'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'Deployment',
  components: {
    MetricGraph,
    MetricData,
    VueLoading
  },
  data () {
    return {
      labels: [],
      metrics: [],
      metric: {},
      loading: false,
      period: 'week',
      date: null,
      lastUpdate: null,
      graphProperties: {},
      added: [],
      removed: [],
      week: this.$moment(this.$moment().toDate(), 'DDMMYYYY').isoWeek(),
      year: this.$moment().year()
    }
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  methods: {
    getCloudformationHistory: function () {
      this.loading = true
      HTTP.get(`/cloudformation/history/${this.activeType}/${this.id}/${this.period}/${this.year}-${this.week}`)
        .then((response) => {
          this.metrics = this.setDataForTimeline(this.sortDeploymentData(response.data.diffs))
          this.date = this.metrics[this.metrics.length - 1].deploy.date
          this.lastUpdate = this.date
          this.graphProperties = {name: 'Deployment', lastUpdate: this.lastUpdate, date: this.date, period: this.period}
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get cloudformation history : ${error.message}`
          })
          this.metrics = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateMetric: function (event) {
      if (event.eventType === 'period') {
        this.period = event.data.period
        this.getCloudformationHistory()
      } else if (event.eventType === 'date') {
        this.date = event.data.date
        this.lastUpdate = event.data.lastUpdate
        this.metric = this.metrics[event.data.metricIndex]

        this.graphProperties = {name: 'Deployment', lastUpdate: event.data.lastUpdate, date: event.data.date, period: this.period}
      } else { // contract
        this.getCloudformationHistory()
      }
    },
    setDataForTimeline (data) {
      return data.map((element, index) => {
        let totalAdd = 0 // eslint-disable-line
        let totalRemove = 0 // eslint-disable-line
        let totalDeployed = 0 // eslint-disable-line
        const RANGE = 11

        for (const key in element.added) {
          totalAdd += element.added[key]
          totalDeployed += element.added[key]
        }

        this.added.push(totalAdd)

        for (const key in element.removed) {
          totalRemove += element.removed[key]
          totalDeployed += element.removed[key]
        }

        this.removed.push(totalRemove)

        element.count = totalDeployed
        element.label = this.week - RANGE + index
        return element
      })
    },
    sortDeploymentData (data) {
      let sortedDeployment = data.sort(function (a, b) {
        let dateA = this.$moment.unix(a.deploy.date)
        let dateB = this.$moment.unix(b.deploy.date)

        if (dateA.diff(dateB) > 0) return 1
        if (dateA.diff(dateB) < 0) return -1

        return 0
      })
      let range = sortedDeployment.length - 12
      let sortedData = sortedDeployment.slice(range, sortedDeployment.length)
      return sortedData
    }
  },
  created: function () {
    this.getCloudformationHistory()
  },
  watch: {
    graphProperties: function () {
      // this.getReport()
    },
    id: function () {
      this.getCloudformationHistory()
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/metric-graph.css'></style>



// WEBPACK FOOTER //
// src/views/Deployment.vue